<template>
  <v-container class="product-instruction pa-0 ml-0">
    <v-card>
      <v-card-text>
        <div v-html="instruction"></div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'ProductInstruction',
  computed: {
    lang () { return this.$store.state['lang']['locale'] },
    instruction: function () {
      let bdInstraction = this.$store.state['products']['current']['instruction']
      if (this.lang === 'en-US') {
        return bdInstraction['description_en']
      }
      return bdInstraction['description_rus']
    }
  }
}
</script>

<style scoped>

</style>